import { RpcService } from '../RpcService';
import { AbstractButtonActionsService } from './AbstractButtonActionsService';
import {
	IButtonActionHidePayload,
	IButtonActionShowPayload,
} from './buttonActionsServiceTypes';

export class ButtonActionsService extends AbstractButtonActionsService {
	constructor(rpc: RpcService) {
		super();

		rpc.register('buttonActions:show', this.handleShowAction.bind(this));
		rpc.register('buttonActions:hide', this.handleHideAction.bind(this));
	}

	private handleShowAction(payload: IButtonActionShowPayload) {
		this.showAction(payload.id, payload.text, payload.button);
	}

	private handleHideAction(payload: IButtonActionHidePayload) {
		this.hideAction(payload.id);
	}
}
